<template>
  <div class="page">
    <div class="banner">
      <Banner :items="bannerList" />
    </div>
    <div class="section2">
	  <div class="parent-box">
      <div class="content containner">
        <div class="text-box">
          <!-- <p class="text1">品倍福一站式</p>
          <p class="text1 mt-20">企业专属福利定制化解决方案</p>
          <p class="text2">满足企业全年福利发放需求</p>
          <p class="text2 mt-20">提供更多员工管理及办公协同服务</p> -->

          <span
            ><img
              class="icon"
              src="@/assets/images/home/section2_1.png"
            />品诺福利-企业服务数智化平台</span
          >
        </div>
        <div class="numberShow">
          <div class="item" v-for="item in section2Data">
            <div class="nums">
              <span>{{ item.val }}</span>
              <span>{{ item.unit }}</span>
            </div>
            <span class="f-18">{{ item.name }}</span>
          </div>
        </div>
      </div>
	  </div>
    </div>

    <div class="section3">
	  <div class="parent-box">
      <div class="com-title"><span>「红耀品诺」</span>-党建引领企业发展</div>
      <div class="com-des">
        以党建为引领，照耀每个人的思想，坚定“一颗红心永向党，矢志不渝跟党走”的决心和信心
      </div>
      <div class="tag">
        <div
          v-for="(item, index) in section3Data"
          :key="item.name"
          :class="section3Index == index ? 'active p-r' : 'p-r'"
          @mouseover="mouseoverSection3(index)"
        >
          <el-image class="icon" :src="item.icon" lazy></el-image>
          <span>{{ item.name }}</span> 
        </div>
      </div>
      <!-- <el-carousel arrow="never" ref="carousel3"  indicator-position="none"  :autoplay="false" >
         <el-carousel-item  v-for="(item,index) in section3Data" :key="index">
			<div class="current-url">
               <el-image  class="iconss" :src="item.url"></el-image>
			</div>
         </el-carousel-item>
       </el-carousel> -->
      <el-image
        class="current-url"
        :src="section3Data[section3Index].url"
        lazy
      ></el-image>
	  </div>
    </div>
   <!-- 品倍福 -->
    <div class="section5">
	  <div class="parent-box  dis-flex  flex-direction flex-y-center">
      <div class="com-title"><span>品倍福</span>-福利智慧化交付及管理平台</div>
      <div class="com-des">打造方便快捷、务实高效的服务职工新通道</div>
      <div class="content5-box">
        <div class="item5" v-for="item in section5Data" :key="item.name">
          <div class="name">
            <span>{{ item.name }}</span>
            <el-image class="icon5" :src="item.icon" lazy></el-image>
          </div>
          <div class="text f-14">{{ item.text }}</div>
        </div>
      </div>
      <div class="com-more m-t-8" @click="moreSee(2)">
        查看更多<el-image
          class="sec_tion"
          :src="require('@/assets/images/home/section.png')"
          lazy
        />
      </div>
	  </div>
    </div>
    <!-- 品诺商城 -->
    <div class="section4">
	  <div class="parent-box  dis-flex  flex-direction flex-y-center">
      <div class="com-title"><span>品诺商城</span>-一站式福利交付平台</div>
      <div class="com-des">
        满足职工年轻化、多元化需求，提供全方位福利解决方案
      </div>
      <div class="content-box">
        <el-image
          class="left"
          :src="require('@/assets/images/home/section4.png')"
          lazy
        ></el-image>
        <div class="right">
          <div v-for="item in section4Data" class="item">
            <div>
              <el-image
                class="section4_icon"
                :src="require('@/assets/images/home/section4_icon.png')"
                lazy
              ></el-image>
              {{ item.name }}
            </div>
            <div>
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="com-more m-t-56" @click="moreSee(1)">
        查看更多<el-image
          class="sec_tion"
          :src="require('@/assets/images/home/section.png')"
          lazy
        />
      </div>
	  </div>
    </div>
    
    <!-- 易企销 -->
    <div class="section6">
		 <div class="parent-box  dis-flex  flex-direction flex-y-center">
      <div class="com-title">
        <span>易企销</span>-职工福利供应链整合及运营平台
      </div>
      <div class="com-des">助力福利行业降本增效</div>
      <div class="content6-box">
        <el-image
          class="section6_left"
          :src="require('@/assets/images/home/section6_left.png')"
          lazy
        ></el-image>
        <el-image
          class="section6_right"
          :src="require('@/assets/images/home/section6_right.png')"
          lazy
        ></el-image>
        <!-- <el-image class="section6_has" :src="require('@/assets/images/home/section6_has.png')" lazy></el-image>
			<el-image class="section6_no" :src="require('@/assets/images/home/section6_no.png')" lazy></el-image>
			<div class="item6" v-for="item in section6Data" :key="item.name">
                  <el-image class="i" lazy :src="item.icon"></el-image><span>{{item.name}}</span> 
			</div> -->
      </div>
      <el-image
        class="img6-box"
        :src="require('@/assets/images/home/主图@2x (3).png')"
      />
      <div class="com-more m-t-20" @click="moreSee(3)">
        查看更多<el-image
          class="sec_tion"
          :src="require('@/assets/images/home/section.png')"
          lazy
        />
      </div>
		 </div>
    </div>

    <!-- 全年福利一站式解决 -->
    <div class="section7">
	  <div class="parent-box dis-flex  flex-direction flex-y-center">
      <div class="com-title">全年福利一站式解决</div>
      <div class="content7-box">
        <div class="tag">
          <div
            v-for="item in section7Data"
            :key="item.key"
            class="tag_item"
            :class="section7keySelect == item.key ? 'active' : ''"
            @click="section7keySelect = item.key;id7=item.id"
          >
            <el-image
              class="img_icn"
              :src="section7keySelect == item.key ? item.s_icon : item.n_icon"
            ></el-image>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <!-- 年节福利 -->
        <div v-if="section7keySelect == 'years'" class="years-box">
          <div class="left-box">
            <div class="left-title">十大年节特色套餐</div>
            <el-image
              class="left-img"
              :src="require('@/assets/images/home/十大年节@2x.png')"
              lazy
            ></el-image>
          </div>
          <div class="right-box">
            <div class="item7">
              <div>京东顺丰等优质快递</div>
              <span>优先发货</span>
            </div>
            <div class="item7">
              <div>全国8仓</div>
              <span>交付稳定 </span>
            </div>
            <div class="item7">
              <div>先行赔付</div>
              <span>售后无忧</span>
            </div>
          </div>
        </div>
        <!-- 生日福利 -->
        <div v-if="section7keySelect == 'brisdays'" class="brisdays-box">
          <div class="left-box">
            <el-image
              class="left-img"
              :src="require('@/assets/images/home/生日福利-主图@2x.png')"
              lazy
            ></el-image>
          </div>
          <div class="right-box">
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image>
                行业领先的蛋糕平台
              </div>
              <span>400+蛋糕品牌，10000+蛋糕商品</span>
            </div>
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image
                >覆盖全国12万余家门店
              </div>
              <span>近300家品牌电子券，覆盖500+城市，12万+家门店可兑 </span>
            </div>
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image
                >蛋糕价格1:1
              </div>
              <span
                >蛋糕价格与品牌售卖正价持平，更有每月“蛋糕特惠”价格直降</span
              >
            </div>
          </div>
        </div>
        <!-- 电影福利 -->
        <div v-if="section7keySelect == 'movies'" class="movies-box">
          <div class="left-box">
            <el-image
              class="left-img"
              :src="require('@/assets/images/home/电影福利-主图@2x.png')"
              lazy
            ></el-image>
          </div>
          <div class="right-box">
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image>
                合作影院覆盖全国
              </div>
              <span>合作16000+影院，覆盖全国690+城市</span>
            </div>
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image
                >头部院线直签
              </div>
              <span>全场次、全时段出票，出票快、价格优 </span>
            </div>
            <div class="brisdaysitem7">
              <div>
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/小圆@2x.png')"
                  lazy
                ></el-image
                >各大影音平台会员通兑
              </div>
              <span>主流音视频平台会员，满足线上观影追剧，每月限时折扣</span>
            </div>
          </div>
        </div>
        <!-- 餐补福利 -->
        <div v-if="section7keySelect == 'foods'" class="foods-box">
          <div class="left-box">
            <el-image
              class="left-img"
              :src="require('@/assets/images/home/餐补福利-主图@2x.png')"
              lazy
            ></el-image>
          </div>
          <el-image
            class="jiantou"
            :src="require('@/assets/images/home/箭头@2x.png')"
            lazy
          ></el-image>
          <div class="right-box dis-flex flex-direction flex-x-between">
            <div class="foodsitem7 dis-flex flex-direction flex-x-center">
              <div class="titl">
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/场景拓展@2x.png')"
                ></el-image>
                场景拓展
              </div>
              <div class="bottom_movie dis-flex flex-y-center">
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>餐卡多元化消费</div>
                </div>
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>线上外卖 / 到店点餐</div>
                </div>
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>生活福利</div>
                </div>
              </div>
            </div>
            <div class="foodsitem7 dis-flex flex-direction flex-x-center">
              <div class="titl">
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/灵活支付@2x.png')"
                ></el-image
                >灵活支付
              </div>
              <div class="bottom_movie dis-flex flex-y-center">
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>支持线下扫码+线上支付</div>
                </div>
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>线上余额+补差价支付</div>
                </div>
              </div>
            </div>
            <div class="foodsitem7 dis-flex flex-direction flex-x-center">
              <div class="titl">
                <el-image
                  class="xy"
                  :src="require('@/assets/images/home/管理提效@2x.png')"
                ></el-image
                >管理提效
              </div>
              <div class="bottom_movie dis-flex flex-y-center">
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>一站式预算统筹</div>
                </div>
                <div class="food_text dis-flex flex-y-center">
                  <el-image
                    class="incs"
                    :src="require('@/assets/images/home/icon@2x(4).png')"
                  ></el-image>
                  <div>统一结算</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 文体活动福利 -->
        <div v-if="section7keySelect == 'actives'" class="actives-box p-r">
          <div
            v-for="item in activeImg"
            :key="item.name"
            class="p-r actives-item"
          >
            <div class="p-a names">{{ item.name }}</div>
            <el-image class="ims_s" :src="item.url" lazy></el-image>
          </div>
          <div class="line p-a">
            <el-image
              :class="['qu1', 'quan p-a']"
              :src="require('@/assets/images/home/小圆@2x.png')"
              lazy
            ></el-image>
            <el-image
              :class="['qu2', 'quan p-a']"
              :src="require('@/assets/images/home/小圆@2x.png')"
              lazy
            ></el-image>
            <el-image
              :class="['qu3', 'quan p-a']"
              :src="require('@/assets/images/home/小圆@2x.png')"
              lazy
            ></el-image>
            <el-image
              :class="['qu4', 'quan p-a']"
              :src="require('@/assets/images/home/小圆@2x.png')"
              lazy
            ></el-image>
            <el-image
              class="i_s p-a"
              :src="require('@/assets/images/home/虚线@2x.png')"
              lazy
            ></el-image>
          </div>
        </div>
      </div>
      <div class="com-more"  @click="moreSee(4)">
        查看更多<el-image
          class="sec_tion"
          :src="require('@/assets/images/home/section.png')"
          lazy
        />
      </div>
		 </div>
    </div>
    <!-- 服务与保障 -->
    <div class="section8">
	  <div class="parent-box dis-flex flex-direction flex-y-center">
      <div class="content8-box p-r">
		<div class="box8-top p-r">
        <div class="com-title">服务与保障</div>
        <div class="title8 f-22 t-c m-t-50 m-b-24">搭建严苛的供应保障体系</div>
        <div class="des8 f-18 t-c m-b-8">全国八大仓储保障高效交付</div>
		</div>
        <div class="right8 dis-flex flex-direction p-a">
          <el-image
            class="img"
            :src="item"
            v-for="(item, index) in section8Data.data"
            :key="index + 'oo'"
          ></el-image>
        </div>
        <div class="bottom8-box dis-flex flex-y-center flex-x-between">
          <div class="tt dis-flex flex-y-center">
            <el-image
              class="img"
              :src="require('@/assets/images/home/快递@2x.png')"
            />
            <span>合作京东、顺丰等优质快递，构建一站式供应链服务</span>
          </div>
          <div class="tt rr dis-flex flex-y-center">
            <el-image
              class="img"
              :src="require('@/assets/images/home/打包@2x.png')"
            />
            <span>接单、打包、发货全流程标准化交付，实时跟踪快递进展</span>
          </div>
        </div>
		<el-image class="ditu8" :src="require('../../assets/images/home/地图@2x.png')"/>
      </div>
	  </div>
    </div>
    <!-- 完善的服务团队 -->
    <div class="section9">
	  <div class="parent-box">
      <div class="title f-22 t-c m-b-30">完善的服务团队</div>
      <div class="des f-18 t-c">建立专业、高效、优质的全链条服务体系</div>
      <div class="content9-box dis-flex m-t-40 flex-x-between">
        <el-image
          class="itemImg"
          :src="item"
          v-for="(item, index) in section9Data.arr1"
          :key="index + 'g'"
        ></el-image>
      </div>
      <div class="title f-22 t-c m-b-30 m-t-98">三大服务通道</div>
      <div class="des f-18 t-c">给职工更及时、更高效、更周到的服务</div>
      <div class="content9-box2 dis-flex m-t-56 flex-x-between">
        <div
          class="items9 p-r"
          v-for="(item, index) in section9Data.arr2"
          :key="index + 'h'"
        >
          <div class="left9">
            <el-image class="icon" :src="item.icon" lazy></el-image>
            <div class="col-3 f-20 m-t-4 f-w m-b-16">{{ item.name }}</div>
            <div class="f-14 col-6 htmls" v-html="item.text"></div>
          </div>
          <el-image class="bg p-a" :src="item.bg" lazy></el-image>
        </div>
      </div>
	  </div>
    </div>
    <div class="section10">
      <div class="top10">
        <div class="dis-flex nubers flex-x-between">
          <div
            class="t_chi_item dis-flex flex-direction flex-y-center"
            v-for="item in section10Data.top1"
            :key="item.text"
          >
            <div class="dis-flex flex-y-center">
              <div class="f-60 col-f f-w nnnn">{{ item.val }}</div>
              <div class="f-22 col-f unitc">{{ item.unit }}</div>
            </div>
            <div class="f-18 col-f m-t-10">{{ item.text }}</div>
          </div>
        </div>
        <div class="dis-flex show-text flex-x-between">
          <div
            class="item-bt t-c f-16 col-f"
            v-for="i in section10Data.top2"
            :key="i + 'm'"
          >
            {{ i }}
          </div>
        </div>
      </div>
      <div class="center10 b-f dis-flex flex-x-between">
        <el-image
          class="center_img"
          :src="i"
          v-for="(i, index) in section10Data.center1"
          :key="'10' + index"
        ></el-image>
      </div>
      <div class="bottom10 p-r dis-flex">
        <div class="part-box part-box1">
          <!-- <div class="chid-boxs"> -->
          <div class="img-box imgbox1">
            <div class="image" v-for="item in 17" :key="item + 'r'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    item + 1
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box p-r imgbox2 flex-x-space">
            <div class="image" v-for="item in 16" :key="item + 'f'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    12 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box imgbox3">
            <div class="image" v-for="item in 17" :key="item + 's'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    24 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box imgbox4 flex-x-space">
            <div class="image" v-for="item in 16" :key="item + 'z'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    30 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div class="part-box part-box2">
          <!-- <div class="chid-boxs"> -->
          <div class="img-box imgbox1">
            <div class="image" v-for="item in 17" :key="item + 'r'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    item + 1
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box p-r imgbox2 flex-x-space">
            <div class="image" v-for="item in 16" :key="item + 'f'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    12 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box imgbox3">
            <div class="image" v-for="item in 17" :key="item + 's'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    24 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <div class="img-box imgbox4 flex-x-space">
            <div class="image" v-for="item in 16" :key="item + 'z'">
              <img
                :src="
                  require(`../../assets/images/home/客户墙000${String(
                    30 + item
                  )}.png`)
                "
                alt=""
              />
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div class="left-box p-a"></div>
        <div class="right-box p-a"></div>
      </div>
    </div>
    <div class="section11">
      <div class="grid-container">
        <div
          v-for="(i, index) in section11Data"
          :key="index"
          class="item11 p-r"
          @mouseenter="changeCity(i)"
        >
          <div
            v-if="currentCity&&i.id === currentCity.id"
            :class="((index+1) % 5) === 0 || ((index+1) % 5) > 3 ? 'toleft' : 'toright'"
            class="active_item first dis-flex flex-y-center"
		        @mouseleave="changeCity(null)"
          >
            <div class="names">
              <div class="col-f f-20 m-b-10">{{ i.name }}</div>
              <div class="col-f f-12 engeng">{{ i.eng }}</div>
            </div>
            <div class="dis-flex flex-direction m-l-20 flex-x-space centers">
              <div class="t-l col-f f-12">地址：{{ i.address }}</div>
              <div class="t-l col-f f-12">电话：{{ i.tel }}</div>
              <div class="t-l col-f f-12">网址：www.pinuc.com</div>
            </div>
            <el-image class="s_icon" fit="contain" :src="i.s_icon"></el-image>
          </div>
          <div class="other-item dis-flex flex-y-center flex-x-between">
            <div class="lefts">
              <div class="m-b-10">
                <span class="f-20">{{ i.name }}</span>
                <el-image
                  class="jiantou"
                  :src="require('@/assets/images/home/箭头@2x(3).png')"
                  lazy
                ></el-image>
              </div>
              <div class="f-12 col-FE8">
                {{ i.eng }}
              </div>
            </div>
            <el-image class="s_n_icon" :src="i.n_icon" lazy></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../../components/banner/banner";
import cascadeBanner from "../../components/banner/cascadeBanner";
import {cityAdress} from './data'
export default {
  name: "Home",
  components: { Banner, cascadeBanner },
  props: {},
  data() {
    return {
      bannerList: [
        {
          img: require("../../assets/images/home/banner-品倍福@2x.png"),
          id: 1,
        },
        {
          img: require("../../assets/images/home/banner-品诺蛋糕@2x.png"),
          id: 3,
        },
        {
          img: require("../../assets/images/home/banner-易企销@2x.png"),
          id: 6,
          link: "http://www.pnyqx.com/",
        },
        {
          img: require("../../assets/images/home/banner-品诺电影@2x.png"),
          id: 2,
        },
        {
          img: require("../../assets/images/home/banner-年节慰问@2x.png"),
          id: 4,
        },
      ],
      currentWelfare: {
        id: 1,
        icon: require("../../assets/images/icon_birthday.png"),
        activeIcon: require("../../assets/images/zu2087.png"),
        text: "生日礼券",
        img: require("../../assets/images/birthday.png"),
        desc: "150+蛋糕品牌，丰富甜品、奶茶水果、巧克力、冰淇淋等",
      }, //当前选中的福利
      cardList: [
        {
          id: 1,
          icon: require("../../assets/images/card1.png"),
          number: "01",
          title: "福利场景覆盖全<br/>一站式兑换体验",
          isFlip: false, //是否翻转
          desc: "覆盖生日蛋糕、电影票、年节礼包、演出、旅游、图书、体检等企业职工福利场景，一站式兑换，无需多个平台跳转。",
        },
        {
          id: 2,
          icon: require("../../assets/images/card2.png"),
          number: "02",
          title: "供应链资源广满足<br/>企业职工多元化需求",
          isFlip: false, //是否翻转
          desc: "自营接入了超过1000家合作供应商，包括京东、海量品牌直签及一级代理等优质资源，保障品质，保证用户体验。",
        },
        {
          id: 3,
          icon: require("../../assets/images/card3.png"),
          number: "03",
          title: "企业团购性价比更高<br/>职工福利更超值",
          isFlip: false, //是否翻转
          desc: "通过聚合全国大中型企业客户海量用户规模，通过直连、大客户协议等深度合作，深耕长期稳固的供应商资源，提供用户更高的性价比，提高企业福利预算效能。",
        },
        {
          id: 4,
          icon: require("../../assets/images/card4.png"),
          number: "04",
          title: "供应商统一管理<br />专业高效、省心省力",
          isFlip: false, //是否翻转
          desc: "专业的供应商整合和管理，让企业的福利品选择更加便捷、高效，帮助企业节省决策时间和流程成本。",
        },
      ], //section4的卡片

     
      section7ActiveId: 1,
      section7Active: {
        id: 1,
        titleIcon: require("../../assets/images/xiaolvtisheng02.png"),
        title: "效率提升",
        contentImg: require("../../assets/images/tab1.png"),
        contentText:
          "企业全年福利系统化<br/>量身定制+一站式全解决<br/>减少超过90%的沟通决策流程成本",
      },
      currentCity: {},
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        paginationClickable: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        autoplay: false,
        scrollbar: ".swiper-scrollbar",
        speed: 300,
        bannerUrl: "",
        allowTouchMove: false,
      },
      currentnew: {
        id: 1,
        pic: require("../../assets/images/se9_1.png"),
        name: "武汉抗疫",
        num: require("../../assets/images/num1.png"),
        num_a: require("../../assets/images/num_a1.png"),
        desc: "2020年初，抗击疫情的阻击战一打响，品诺人冲锋在前，第一时间向武汉抗疫一线筹集防疫物资，捐款捐物全力支持防疫。",
      },
      section2Data: [
        {
          name: "行业经验",
          val: 10,
          unit: "年",
        },
        {
          name: "分支机构",
          val: '17',
          unit: "个",
        },
        {
          name: "团队规模",
          val: 800,
          unit: "+",
        },
        {
          name: "服务工会数",
          val: 50000,
          unit: "+",
        },
        {
          name: "服务职工数",
          val: 3000,
          unit: "万+",
        },
      ],
      section3Data: [
        {
          name: "坚持全员统一思想，全司统一行动",
          icon: require("@/assets/images/home/setion3_1i.png"),
          url: require("@/assets/images/home/setion3_1.png"),
        },
        {
          name: "坚持优化内部制度，赋能业务发展",
          icon: require("@/assets/images/home/setion3_2i.png"),
          url: require("@/assets/images/home/setion3_2.png"),
        },
        {
          name: "坚持履行社会责任，创造社会价值",
          icon: require("@/assets/images/home/setion3_3i.png"),
          url: require("@/assets/images/home/setion3_3.png"),
        },
      ],
      section3Index: 0,
      section4Data: [
        {
          name: "全年福利一站交付",
          text: "涵盖蛋糕、电影、节日套餐等福利资源满足企业全年采购需求",
          selectedIndex: false,
        },
        {
          name: "专属展示界面",
          text: "企业专属界面设计、功能版块展示",
          selectedIndex: false,
        },
        {
          name: " 按需定制福利方案",
          text: "满足全年各节日个性化福利采购需求",
          selectedIndex: false,
        },
        {
          name: "定期特惠超值选兑",
          text: "每周、每月均有特惠活动，帮职工精打细算",
          selectedIndex: false,
        },
      ],
      section5Data: [
        {
          name: "全年福利一站兑",
          text: "分散的福利统一管理，高效交付",
          icon: require("@/assets/images/home/section5_1.png"),
        },
        {
          name: "专属福利智慧化系统",
          text: "福利版块 / 系统功能 / 视觉界面可定制",
          icon: require("@/assets/images/home/section5_2.png"),
        },
        {
          name: "工会办公线上化",
          text: "线下转线上，助力“数字工会”落地",
          icon: require("@/assets/images/home/section5_3.png"),
        },
        {
          name: "便捷的活动管理",
          text: "10余项活动功能，让活动组织更简单",
          icon: require("@/assets/images/home/section5_4.png"),
        },
      ],
      section6Data: [
        {
          name: "场景多覆盖",
          icon: require("@/assets/images/home/section6_1.png"),
        },
        {
          name: "资源全囊括",
          icon: require("@/assets/images/home/section6_2.png"),
        },
        {
          name: "数字化系统",
          icon: require("@/assets/images/home/section6_3.png"),
        },
        {
          name: "全方位保障",
          icon: require("@/assets/images/home/section6_4.png"),
        },
      ],
      section7Data: [
        {
          name: "年节福利",
          s_icon: require("@/assets/images/home/年节福利-选中@2x.png"),
          n_icon: require("@/assets/images/home/年节福利-未选中@2x.png"),
          key: "years",
		  id:1,
        },
        {
          name: "生日福利",
          s_icon: require("@/assets/images/home/生日福利-选中@2x.png"),
          n_icon: require("@/assets/images/home/生日福利-未选中@2x.png"),
          key: "brisdays",
		  id:2,
        },
        {
          name: "电影福利",
          s_icon: require("@/assets/images/home/电影福利-选中@2x.png"),
          n_icon: require("@/assets/images/home/电影福利-未选中@2x.png"),
          key: "movies",
		  id:3,
        },
        {
          name: "员工餐补",
          s_icon: require("@/assets/images/home/餐补福利-选中@2x.png"),
          n_icon: require("@/assets/images/home/餐补福利-未选中@2x.png"),
          key: "foods",
		  id:4,
        },
        {
          name: "文体活动福利",
          s_icon: require("@/assets/images/home/文体活动福利-选中@2x.png"),
          n_icon: require("@/assets/images/home/文体活动福利-未选中@2x.png"),
          key: "actives",
		  id:5,
        },
      ],
	  id7:1,
      section7keySelect: "years",
	  marginTop:{
           years:'m-t-60',
           brisdays:'m-t-16',
           movies:'m-t-16',
           foods:'m-t-12',
           actives:'m-t-22',
	  },
      //   文体活动福利
      activeImg: [
        {
          name: "公司团建",
          url: require("@/assets/images/home/公司团建@2x (1).png"),
        },
        {
          name: "红色党建",
          url: require("@/assets/images/home/红色党建@2x (1).png"),
        },
        {
          name: "会议服务",
          url: require("@/assets/images/home/会议服务@2x (1).png"),
        },
        {
          name: "年节活动",
          url: require("@/assets/images/home/年节活动@2x (2).png"),
        },
        {
          name: "户外拓展",
          url: require("@/assets/images/home/户外拓展@2x (1).png"),
        },
        {
          name: "亲子活动",
          url: require("@/assets/images/home/亲子活动@2x (1).png"),
        },
        {
          name: "企业联谊",
          url: require("@/assets/images/home/企业联谊@2x (1).png"),
        },
        {
          name: "线上互动",
          url: require("@/assets/images/home/线上互动@2x (1).png"),
        },
      ],
      section8Data: {
        mainUrl: require("@/assets/images/home/地图@2x.png"),
        data: [
          require("@/assets/images/home/仓库1@2x.png"),
          require("@/assets/images/home/仓库2@2x.png"),
          require("@/assets/images/home/仓库3@2x.png"),
          require("@/assets/images/home/仓库4@2x.png"),
        ],
      },
      section9Data: {
        arr1: [
          require("@/assets/images/home/顾问@2x.png"),
          require("@/assets/images/home/采购@2x.png"),
          require("@/assets/images/home/运营@2x.png"),
          require("@/assets/images/home/技术@2x.png"),
          require("@/assets/images/home/客服@2x.png"),
        ],
        arr2: [
          {
            name: "在线客服",
            icon: require("@/assets/images/home/在线客服@2x.png"),
            text: "智能客服系统<br/>24小时在线服务",
            bg: require("@/assets/images/home/01@2x(1).png"),
          },
          {
            name: "400客服",
            icon: require("@/assets/images/home/400客服@2x.png"),
            text: "自有客服团队<br/>7*12小时全年无休",
            bg: require("@/assets/images/home/02@2x(1).png"),
          },
          {
            name: "自助售后",
            icon: require("@/assets/images/home/售后@2x.png"),
            text: "在线取消订单<br/>申请退货",
            bg: require("@/assets/images/home/03@2x(1).png"),
          },
        ],
      },
      section10Data: {
        top1: [
          {
            val: 50000,
            unit: "+",
            text: "服务工会数",
          },
          {
            val: 3000,
            unit: "万+",
            text: "服务职工数",
          },
          {
            val: 10,
            unit: "年",
            text: "行业经验",
          },
        ],
        top2: [
          "政府/事业单位",
          "央企/国企",
          "教育文娱",
          "基建工程",
          "银行金融",
          "航空航天",
        ],
        center1: [
          require("@/assets/images/home/01@2x (1).png"),
          require("@/assets/images/home/01@2x.png"),
          require("@/assets/images/home/02@2x.png"),
          require("@/assets/images/home/03@2x.png"),
          require("@/assets/images/home/04@2x.png"),
        ],
      },
      section11Data:cityAdress,
      offsetX: 0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 鼠标移入切换福利板块
    changeWelfare(val) {
      this.currentWelfare = val;
    },
    // 为什么选择品诺福利？
    changeTab(item) {
      this.section7Active = item;
      this.section7ActiveId = item.id;
    },
    // 鼠标移入选择城市
    changeCity(val) {
      this.currentCity = val;
    },
    // 鼠标移入section9
    display9(val) {
      this.currentnew = val;
    },
    //鼠标移入section3{}
    mouseoverSection3(index) {
      this.section3Index = index;
    //   this.$refs.carousel3.setActiveItem(index);
    },
    //查看更多
    moreSee(type) {
      switch (type) {
        case 1:
          this.$router.push("/pnsc");
          break;
        case 2:
          this.$router.push("/pbf");
          break;
        case 3:
          this.$router.push("/pnyqx");
          break;
        case 4:
          this.$router.push({
			path:`/jjfa?id=${this.id7}`,
		  });
          break;

        default:
          break;
      }
    },
  },
  filters: {},
  computed: {},
  watch: {},
};
</script>

<style lang="less" scoped>
.page {
  position: relative;
//   top: 70px;
  font-family: Source Han Sans CN;
}

.com-title {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 36px;
  color: #333333;
  text-align: center;
  span {
    color: #fe9c2c;
  }
}
.com-des {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  text-align: center;
  margin-top: 28px;
}
.com-more {
  cursor: pointer;
  width: 270px;
  height: 48px;
  background: #fe9c2c;
  border-radius: 10px 10px 10px 10px;
  text-align: center;
  line-height: 48px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-size: 16px;
  color: #ffffff;
  max-height: 48px;

  .sec_tion {
    width: 16px;
    height: 12px;
    display: inline-block;
    margin-left: 2px;
  }
}

.banner {
  position: relative;
//   height: 540px;
}
.section2 {
  width: 100%;
  background: url("../../assets/images/home/section2_2.png") no-repeat;
    background-position: bottom left;
    background-size: 100% auto;
    height: 387px;

  .content {
    height: 387px;
    width: 100%;
    .text-box {
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      span {
        color: #333;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 36px;
        color: #333333;
        margin-top: 98px;
        display: inline-block;
        position: relative;
        z-index: 12;
        img {
          width: 25px;
          height: 25px;
          display: inline-block;
          position: absolute;
          left: -8px;
          top: -8px;
          z-index: -1;
        }
      }
    }
    .numberShow {
      display: flex;
      width: 100%;
      padding: 80px 0px;
      box-sizing: border-box;
      justify-content: space-between;
      .nums {
        margin-bottom: 8px;
        span {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 42px;
          color: #fe9c2c;
          &:nth-child(2) {
            font-size: 18px;
          }
        }
      }
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
.section3 {
  height: 812px;
  padding-top: 100px;
  background: #fcf9f7;

  .tag {
    padding: 0 77px;
    box-sizing: border-box;

    display: flex;
    justify-content: space-between;
    margin-bottom: 70px;
    margin-top: 80px;
    div {
      position: relative;
      cursor: pointer;
      width: 283px;
      height: 56px;
     
      .icon {
        width: 40px;
        height: 40px;
        display: inline-block;
        position: absolute;
        left: 0;
        top: -36px;
        background: transparent;
        z-index: 12;
        box-shadow: 0px 0px 0px 0px;
      }
	  span{
		 display: block;
		 background: linear-gradient(90deg, #fffff8 0%, #fff0ee 100%);
         box-shadow: 3px 3px 4px 1px rgba(255, 114, 41, 0.24);
         border-radius: 6px 6px 6px 6px;
         line-height: 56px;
         text-align: center;
         font-family: Source Han Sans CN, Source Han Sans CN;
         font-weight: 400;
         font-size: 16px;
         color: #ff7635;
         z-index: 212;
	     width: 283px;
         height: 56px;
		 position: absolute;
		 left: 0;
		 top: 0;
	  }
    }
    .active {
		span{
      background: linear-gradient(90deg, #ffc758 0%, #ff9c2c 100%);
      box-shadow: 3px 3px 4px 1px rgba(242, 83, 0, 0.24);
      color: #ffffff;
      z-index: 212;
		}
     
      position: relative;
    }
  }
  .current-url {
    margin: 0 auto;
    display: block;
    max-width: 1200px;
    min-height: 360px;
    position: relative;
    // .iconss{
    // 	min-height:360px;
    // }
  }
}
/deep/ .el-carousel__item {
  min-height: 360px;
}
.section4 {
  // height: 920px;
  height: 946px;
  padding-top: 99px;
  background: #fcf9f7;
  box-sizing: border-box;
  .content-box {
    display: flex;
    justify-content: center;
    margin-top: 57px;
    .left {
      width: 590px;
      height: 500px;
      display: block;
    }
    .right {
      margin-left: 100px;
      padding-top: 24px;
      .item {
        cursor: pointer;
        width: 478px;
        height: 110px;
        display: flex;
        padding: 32px 34px;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: center;
        .section4_icon {
          width: 15px;
          height: 15px;
          display: inline-block;
          margin-right: 2px;
        }
        div {
          &:nth-child(1) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            text-align: left;
          }
          &:nth-child(2) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            text-align: left;
            margin-top: 10px;
			padding-left: 22px;
          }
        }
      }
      .item:hover {
        background: url("../../assets/images/home/section4_select.png");
        background-size: 100% 100%;
        // margin-left: -25px;
        // padding-left: 40px;
        transition: all 0.1s linear;
        div {
          &:nth-child(2) {
            color: #333;
          }
        }
      }
    }
  }
  
}
@keyframes rotate {
  0% {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, 0deg);
  }
  100% {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, 360deg);
  }
}
.section5 {
  height: 915px;
  //   // background: #e88c35;
  //   background-image: url('../../assets/images/section5_bg.png');
  //   background-size: 100% auto;
  box-sizing: border-box;
  padding-top: 100px;
  .content5-box {
    margin: 0 auto;
    width: 1221px;
    height: 537px;
    background-image: url("../../assets/images/home/section5.png");
    background-size: 100% auto;
    margin-top: 37px;
    position: relative;
    .item5 {
      width: 278px;
      height: 91px;
      background: #ffffff;
	  box-shadow: 3px 3px 10px 1px rgba(255,193,123,0.4);
      border-radius: 12px 12px 12px 12px;
	  border: 1px solid #FFE4C5;
      padding: 16px 15px 22px 20px;
      box-sizing: border-box;
      position: absolute;
      cursor: pointer;
      &:nth-child(1) {
        left: 78px;
        top: 119px;
      }
      &:nth-child(2) {
        left: 78px;
        bottom: 125px;
      }
      &:nth-child(3) {
        right: 84px;
        top: 130px;
      }
      &:nth-child(4) {
        right: 84px;
        bottom: 125px;
      }
    }
    .name {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ff7b0b;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icon5 {
        width: 36px;
        height: 36px;
        vertical-align: middle;
      }
    }
    .text {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #d49661;
    }
    .item5:hover {
      box-shadow: 3px 3px 12px 1px rgba(204, 92, 0, 0.26);
    }
  }
  //   .mycarousel {
  //     padding-bottom: 60px;
  //     box-sizing: border-box;
  //     .text1 {
  //       margin-top: 114px;
  //       font-size: 40px;
  //       font-family: Source Han Sans CN;
  //       font-weight: bold;
  //       color: #ffffff;
  //       text-align: center;
  //     }
  //     .text2 {
  //       font-size: 30px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 300;
  //       color: #ffffff;
  //       margin: 18px auto 45px;
  //       text-align: center;
  //     }
  //     .img-box {
  //       display: flex;
  //       flex-wrap: wrap;
  //       margin: 0 auto;
  //       padding: 0 20px;
  //       justify-content: center;
  //       align-items: center;
  //       .image {
  //         width: 12%;
  //         // height: 64px;
  //         background: #ffffff;
  //         border-radius: 5px;
  //         margin-right: 16px;
  //         margin-bottom: 16px;
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         img {
  //           border-radius: 5px;
  //           width: 100%;
  //         }
  //       }
  //     }
  //     .swiper-pagination {
  //       bottom: 30px;
  //     }
  //   }
}
.line_dark {
  height: 16px;
  background: #494747;
}
.section6 {
  height: 928px;
  background: #fff;
  padding-top: 100px;
  box-sizing: border-box;
  position: relative;
  .img6-box {
	max-width: 1120px;
	min-width: 1120px;
    height: 511px;
    position: absolute;
       left: 50%;
	transform: translateX(-50%);
    top: 239px;
  }
  .content6-box {
    height: 520px;
    width: 707px;
    // background-image: url('../../assets/images/home/section6.png');
    // background-size: 100% auto;
    margin: 0 auto;
    margin-top: 56px;
    position: relative;

    .section6_left {
      position: absolute;
      width: 185px;
      height: 187px;
      left: -286px;
      top: 38px;
    }
    .section6_right {
      position: absolute;
      width: 185px;
      height: 186px;
      right: -215px;
      bottom: -41px;
    }
    .section6_has {
      width: 176px;
      height: 76px;
      position: absolute;
      left: -193px;
      top: 130px;
    }
    .section6_no {
      position: absolute;
      width: 176px;
      height: 76px;
      left: -193px;
      top: 232px;
    }
    .item6 {
      width: 176px;
      height: 50px;
      background: #ffffff;
      box-shadow: 4px 4px 8px 1px rgba(238, 119, 0, 0.26);
      border-radius: 25px 25px 25px 25px;
      border: 1px solid #fe9c2c;
      padding: 4px 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: absolute;
      .i {
        width: 42px;
        height: 42px;
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 20px;
        color: #ff7b0b;
      }
      &:nth-child(5) {
        top: 57px;
        right: -100px;
      }
      &:nth-child(6) {
        top: 172px;
        right: -155px;
      }
      &:nth-child(7) {
        top: 288px;
        right: -159px;
      }
      &:nth-child(8) {
        top: 404px;
        right: -111px;
      }
    }
  }
  //   .box {
  //     position: relative;
  //     display: flex;
  //     justify-content: space-between;
  //   }
  //   .left {
  //     margin-top: 138px;
  //     .tit {
  //       width: 662px;
  //       box-sizing: border-box;
  //       padding: 15px 20px;
  //       border: 3px solid #e88c35;
  //       font-size: 36px;
  //       font-family: Source Han Sans CN;
  //       font-weight: bold;
  //       color: #e88c35;
  //     }
  //     .stit {
  //       font-size: 24px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       color: #e88c35;
  //       margin: 18px 0;
  //     }
  //     .info {
  //       font-size: 20px;
  //       font-family: Source Han Sans CN;
  //       line-height: 34px;
  //       color: #999999;
  //     }
  //   }
  //   .right {
  //     position: absolute;
  //     right: 0;
  //     top: 60px;
  //     img {
  //       width: 600px;
  //     }
  //   }
}
.section6-2 {
  height: 560px;
  background: #fff;
  .box {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }
  .left {
    position: absolute;
    left: 0;
    top: 60px;
    img {
      width: 537px;
    }
  }
  .right {
    margin-top: 138px;
    margin-right: 175px;
    .tit {
      width: 332px;
      box-sizing: border-box;
      padding: 15px 20px;
      border: 3px solid #e88c35;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #e88c35;
    }
    .stit {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #e88c35;
      margin: 18px 0;
    }
    .info {
      font-size: 20px;
      font-family: Source Han Sans CN;
      line-height: 34px;
      color: #999999;
    }
  }
}

.section7 {
  height: 976px;
  min-width: 1200px;
  background: url("../../assets/images/home/section7.png");
  background-size: 97% 100%;
  -moz-background-size: 97% 80%;
  padding-top: 99px;
  box-sizing: border-box;
  margin: 0 auto;
  //   /deep/ .el-tabs__nav-wrap{
  // 	&::after{
  // 		display: none;
  // 	}
  //   }
  .content7-box {
    width: 1110px;
    margin: 0 auto;
    margin-top: 57px;
    .tag {
      display: flex;
      justify-content: space-between;
    }
    .tag_item {
      cursor: pointer;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 22px;
      box-sizing: border-box;
      border-bottom: 1px solid #cccccc;
      .img_icn {
        width: 36px;
        height: 36px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top: -2px;
      }
    }
    .active {
      color: #fe8829;
      position: relative;
      border-bottom: none;
      &::after {
        content: " ";
        position: absolute;
        width: 100%;
        height: 1px;
        background: #fe8829;
        bottom: 0;
        left: 0;
      }
    }
    .years-box {
      background: url("../../assets/images/home/主图@2x.png") no-repeat;
      background-size: 100%;
      height: 504px;
      margin-top: 35px;
      margin-bottom: 44px;
      position: relative;
      .left-box {
        position: absolute;
        top: 63px;
        left: 60px;
        width: 263px;
      }
      .left-img {
        height: 377px;
        vertical-align: middle;
        display: inline-block;
      }
      .left-title {
        position: absolute;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 19px;
        color: #fe8829;
        left: 50%;
        transform: translateX(-50%);
        top: 28px;
        z-index: 2;
        white-space: nowrap;
      }
      .right-box {
        position: absolute;
        right: 71px;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: 118px;
        padding-bottom: 80px;
        box-sizing: border-box;
        height: 100%;
        .item7 {
          cursor: pointer;
          width: 269px;
          height: 73px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 23px;
          box-sizing: border-box;
          div {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 19px;
            color: #fe8829;
            margin-bottom: 7px;
          }
          span {
            display: block;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 13px;
            color: #333333;
          }
          &:hover {
            background: linear-gradient(
              270deg,
              rgba(254, 135, 44, 0) 0%,
              #fe872c 100%
            );
            border-radius: 4px;
            div,
            span {
              color: #fff;
            }
          }
        }
      }
    }
    .brisdays-box,
    .movies-box {
      margin-top: 36px;
      display: flex;
      margin-bottom: 34px;
      .left-img {
        height: 506px;
        min-width: 630px;
      }
      .right-box {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding-bottom: 66px;
        padding-top: 45px;
        margin-left: 112px;
      }
      .brisdaysitem7 {
        cursor: pointer;
        width: 525px;
        height: 134px;
        //  background: #FFFFFF;
        //  box-shadow: 3px 3px 8px 1px rgba(255,217,174,0.6);
        //  border: 1px solid #FFDFD0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 29px;
        box-sizing: border-box;
        .xy {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin-right: 6px;
        }
        div {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin-bottom: 6px;
        }
        span {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #999999;
          display: block;
          padding-left: 21px;
        }
        &:hover {
          background: url("../../assets/images/home/文案底框@2x.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .movies-box {
      .brisdaysitem7 {
        &:hover {
          background: url("../../assets/images/home/文案底框@2x(1).png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .foods-box {
      display: flex;
      align-items: center;
      margin-top: 40px;
      margin-bottom: 32px;
      .left-img {
        height: 510px;
        min-width: 496px;
        display: block;
      }
      .jiantou {
        height: 215px;
        min-width: 82px;
      }
      .right-box {
        margin-left: 50px;
        height: 100%;
        padding-top: 31px;
        height: 510px;
        padding-bottom: 54px;
        box-sizing: border-box;
      }
      .foodsitem7 {
        cursor: pointer;
        width: 567px;
        height: 119px;
        background: linear-gradient(270deg, #ffffff 0%, #ffffff 100%);
        padding: 12px 27px;
        box-sizing: border-box;
        border-radius: 12px;
        .titl {
          position: relative;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          &::after {
            content: " ";
            display: inline-block;
            position: absolute;
            width: 422px;
            height: 2px;
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0) 0%,
              #ff963e 100%
            );
            border-radius: 0px 0px 0px 0px;
            left: 0;
            bottom: 0;
          }
        }
        .xy {
          width: 44px;
          height: 44px;
          vertical-align: middle;
        }
        .bottom_movie {
          margin-top: 18px;
          .incs {
            width: 10px;
            height: 10px;
            display: block;
            margin-right: 6px;
          }
          .food_text {
            margin-right: 44px;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }
        &:hover {
          box-shadow: 3px 3px 16px 1px rgba(238, 119, 0, 0.2);
        }
      }
    }
    .actives-box {
      width: 1048px;
      display: grid;
      grid-template-columns: 266px 266px 266px 266px;
      margin: 0 auto;
      margin-top: 28px;
      grid-row-gap: 88px;
      margin-bottom:67px;
      // height: ;
      .ims_s {
        height: 200px;
        min-width: 236px;
      }
      .actives-item {
        height: 200px;
        width: 236px;
        cursor: pointer;
        .names {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 19px;
          color: #333333;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
        }
      }
      .actives-item:hover {
        .names {
          color: #ff8800;
        }
        background: rgba(255,255,255,0.6);
        box-shadow: inset 0px 1px 0px 1px #FFFFFF;
        box-shadow: 3px 3px 12px 1px rgba(204,92,0,0.26);
		// background: rgba(255,255,255,0.6);
        // box-shadow: inset 0px 4px 12px 2px #FFFFFF;
        border-radius: 8px;
        font-size: 50px;
        animation: tops 0.2s linear;
        top: -10px;
      }
      .i_s {
        height: 4px;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        left: 0;
      }
      .line {
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        z-index: 2;
        .quan {
          height: 20px;
          width: 20px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 323;
        }
        .qu1 {
          left: 108px;
        }
        .qu2 {
          left: 375px;
        }
        .qu3 {
          left: 639px;
        }
        .qu4 {
          left: 906px;
        }
      }
    }
  }
  //   .title {
  //     font-size: 40px;
  //     font-family: Source Han Sans CN;
  //     font-weight: bold;
  //     color: #e78b36;
  //     margin-top: 50px;
  //     text-align: center;
  //   }
  //   .tabs {
  //     width: 908px;
  //     height: 54px;
  //     border: 1px solid #e88c35;
  //     border-radius: 4px;
  //     display: flex;
  //     margin: 40px auto;
  //     z-index: 1000;
  //     .tab {
  //       display: flex;
  //       height: 100%;
  //       align-items: center;
  //       width: 227px;
  //       justify-content: center;
  //       color: #fff;
  //       cursor: pointer;
  //       &.active {
  //         background: #e88c35;
  //         color: #2a2828;
  //       }
  //       .image {
  //         width: 28px;
  //         height: 28px;
  //       }
  //       .text {
  //         margin-left: 7px;
  //         font-family: Source Han Sans CN;
  //         font-size: 28px;
  //       }
  //     }
  //   }
  //   .content {
  //     display: flex;
  //     margin-top: 74px;
  //     // width: 100%;
  //     align-items: center;
  //     .left {
  //       width: 50%;
  //       border-right: 1px dashed #e88c35;
  //       text-align: center;
  //       img {
  //         width: 410px;
  //         height: 170px;
  //       }
  //     }
  //     .right {
  //       font-size: 30px;
  //       font-family: Source Han Sans CN;
  //       line-height: 51px;
  //       color: #e88c35;
  //       margin-left: 47px;
  //     }
  //   }
}
.section77 {
  background: url("../../assets/images/section77_bg.png") no-repeat;
  background-size: 100%;
  height: 600px;
  padding-top: 1px;
  .box {
    .title {
      text-align: center;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #e88c35;
      margin-top: 84px;
      margin-bottom: 92px;
    }
  }
  .data-box {
    display: flex;
    justify-content: space-between;
    .item {
      position: relative;
      width: 170px;
      margin-right: 35px;
      text-align: center;
      &:hover {
        .name {
          color: #e88c35;
        }
        .tags {
          .tag {
            background: #e88c35;
          }
        }
        .icon {
          display: none;
        }
        .activeicon {
          display: block;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      .lianjie {
        position: absolute;
        top: 32px;
        left: 168px;
        img {
          height: 14px;
        }
      }
      .icon {
        img {
          width: 64px;
        }
      }
      .activeicon {
        display: none;
        img {
          width: 64px;
        }
      }
      .name {
        margin: 26px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .tags {
        display: flex;
        flex-wrap: wrap;
        .tag {
          width: 48%;
          margin-right: 4px;
          margin-bottom: 4px;
          background: #333333;
          border-radius: 2px;
          padding: 7px 0;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #f9f8f9;
          &:nth-child(2n) {
            margin-right: 0;
          }
          &.tag2 {
            width: 100%;
            margin-right: 0;
          }
        }
      }
    }
  }
}

.section8 {
  position: relative;

  .content8-box {
    padding-top: 86px;
    box-sizing: border-box;
    height: 1106px;
    // max-width: 1620px;
	width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    // background: url("../../assets/images/home/地图@2x.png") no-repeat;
    // background-size: 100% 100%;
	.ditu8{
		height:1106px;
		width: 1620px;
		position: absolute;
		z-index: -2;
		left:50%;
		transform: translateX(-50%);
		top: 20px;
	}
    .com-title {
      letter-spacing: 4px;
    }
    .right8 {
      right: 120px;
      top: 200px;
      .img {
        width: 156px;
        height: 156px;
        margin-bottom: 30px;
      }
    }
    .bottom8-box {
      position: absolute;
      bottom: 97px;
      left: 50%;
      transform: translateX(-50%);
      .img {
        width: 34px;
        height: 34px;
      }
      span {
        white-space: nowrap;
        padding-left: 11px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
        color: #fe9c2c;
      }
      .tt {
        width: 460px;
        height: 42px;
        background: #fffcf0;
        border-radius: 21px 21px 21px 21px;
        border: 1px solid #fe9c2c;
        padding-left: 4px;
        box-sizing: border-box;
      }
      .rr {
        margin-left: 40px;
      }
    }
	.box8-top{
       top: -20px;
	}
  }
  .title8 {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #fe9c2c;
  }
  .des8 {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #666666;
  }
}
.section9 {
  //   background: #383538;
  //   background-image: url('../../assets/images/section9_bg.png');
  //   background-size: 100%;
  //   padding-top: 6px;
  height: 818px;
  background: #fcf9f7;
  border-radius: 0px 0px 0px 0px;
  padding-top: 103px;
  box-sizing: border-box;
  .title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #fe9c2c;
  }
  .des {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #666666;
  }
  .itemImg {
    width: 178px;
    height: 138px;
  }
  .content9-box {
    width: 1010px;
    padding: 0 30px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 50px;
  }
  .content9-box2 {
    width: 1010px;
    padding: 0 70px;
    padding-left: 108px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 56px;
    .items9 {
      width: 182px;
      height: 182px;
      background-size: 100%;
      .bg {
        height: 182px;
        width: 182px;
        left: 0;
        bottom: 0;
        z-index: 2;
      }
      .icon {
        width: 46px;
        height: 46px;
        display: inline-block;
      }
      .htmls {
        line-height: 24px;
      }
      .left9 {
        position: relative;
        left: -38px;
        top: 10px;
      }
    }
  }
  //   .title {
  //     width: 938px;
  //     height: 100px;
  //     border: 6px solid #ffffff;
  //     color: #fff;
  //     margin: 80px auto 0;
  //     font-size: 32px;
  //     font-family: Source Han Sans CN;
  //     font-weight: bold;
  //     margin: 80px auto 0;
  //     padding: 33px 0 31px;
  //     text-align: center;
  //   }
  //   .honor {
  //     margin-top: 109px;
  //     .cardbaner {
  //       margin: auto;
  //       width: 440px;
  //       height: 390px;
  //       background: #e88c35;
  //     }
  //   }
}
.section99 {
  // height: 765px;
  background: #e88c35;
  padding-top: 90px;
  padding-bottom: 83px;
  .title {
    text-align: center;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #3b383b;
    margin-bottom: 20px;
  }
  .subtit {
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN;
    color: #3b383b;
  }
  .content {
    margin-top: 24px;
    .card {
      display: flex;
      .item {
        position: relative;
      }
      .c-item {
        padding: 54px 32px;
        width: 180px;
        height: 333px;
        cursor: pointer;
        .num {
          img {
            width: 84px;
            height: 64px;
          }
        }
        .name {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #666666;
          margin-top: 18px;
          margin-bottom: 16px;
        }
        .dian {
          img {
            width: 39px;
            height: 6px;
          }
        }
        .spotbox {
          margin-bottom: 10px;
          .spot {
            display: inline-block;
            margin-right: 5px;
            width: 6px;
            height: 6px;
            background: #e88c35;
            border-radius: 50%;
            &:nth-child(2) {
              opacity: 0.86;
            }
            &:nth-child(3) {
              opacity: 0.61;
            }
            &:nth-child(4) {
              opacity: 0.42;
            }
          }
        }
        .desc {
          font-size: 16px;
          font-family: Source Han Sans CN;
          line-height: 24px;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .card-a-item {
        width: 480px;
        height: 333px;
        padding: 72px 25px 62px 33px;
        position: relative;
        .jiantou {
          position: absolute;
          top: 67px;
          right: -20px;
          z-index: 100;
          img {
            width: 40px;
            height: 40px;
          }
        }
        .c-a-item {
          display: flex;
          justify-content: space-between;
          .pic {
            margin-right: 28px;
            img {
              width: 186px;
              height: 186px;
            }
          }
          .right {
            .name {
              position: relative;
              .num {
                margin-left: 25px;
                img {
                  width: 84px;
                  height: 64px;
                }
              }
              .name-text {
                position: absolute;
                top: 32px;
                font-size: 28px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                line-height: 0px;
                color: #fe922e;
              }
            }
            .desc {
              font-size: 16px;
              font-family: Source Han Sans CN;
              line-height: 24px;
              color: #fe922e;
            }
          }
        }
      }
    }
  }
}
.section10 {
  background: #fcf9f7;
  .top10 {
    background: url("../../assets/images/home/背景底纹@2x.png") no-repeat;
    background-size: 100% 100%;
    height: 438px;
    padding-top: 86px;
    box-sizing: border-box;
    .nubers {
      width: 1200px;
      padding: 0 160px;
      box-sizing: border-box;
      margin: auto;
      .nnnn {
        letter-spacing: 2px;
      }
    }
    .unitc {
      position: relative;
      top: 14px;
    }
    .show-text {
      width: 1200px;
      margin: 0 auto;
      margin-top: 60px;
      .item-bt {
        width: 160px;
        height: 42px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 8px 8px 8px 8px;
        line-height: 42px;
        z-index: 12;
      }
    }
  }
  .center10 {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    top: -84px;
    padding: 36px 32px;
    box-sizing: border-box;
    box-shadow: 2px 2px 16px 1px rgba(204, 92, 0, 0.1);
    border-radius: 8px;
    .center_img {
      width: 218px;
      height: 160px;
    }
  }
  .bottom10 {
    min-height: 240px;
    width: 1400px;
    overflow: hidden;
    margin: 0 auto;
    padding: 10px 0;
    box-sizing: border-box;
    margin-top: -30px;
    padding-bottom: 100px;

    .part-box1 {
      background: #fcf9f7;
      // white-space: nowrap;
      // background: #fff;
      animation: lunbo 50s linear infinite;
    }
    .part-box2 {
      background: #fcf9f7;
      animation: lunbo2 50s linear infinite;
      animation-delay: -25s;
    }
    &:hover {
      .part-box2,
      .part-box1 {
        animation-play-state: paused;
      }
    }

    .img-box {
      overflow: auto;
      display: flex;
      margin: 0 auto;
      padding-top: 0;
      padding-bottom: 0;
      justify-content: space-between;
      align-items: center;
      .image {
        min-width: 154px;
        max-width: 154px;
        // height: 64px;
        height: 60px;
        background: transparent;
        border-radius: 5px;
        margin-right: 16px;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          border-radius: 5px;
          width: 100%;
        }
      }
      // .zhiding1 {
      //   position: absolute;
      //   left: -180px;
      //   min-width: 154px;
      //   // height: 64px;
      //   height: 60px;
      //   background: transparent;
      //   border-radius: 5px;
      //   margin-right: 16px;
      //   margin-bottom: 16px;
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      //   img {
      //     border-radius: 5px;
      //     width: 100%;
      //   }
      // }
    }
    .left-box {
      width: 360px;
      height: 240px;
      background: linear-gradient(
        270deg,
        rgba(253, 251, 249, 0) 0%,
        #fdfbf9 100%
      );
      border-radius: 0px 0px 0px 0px;
      left: 0;
    }
    .right-box {
      width: 360px;
      height: 240px;
      background: linear-gradient(
        90deg,
        rgba(253, 251, 249, 0) 0%,
        #fdfbf9 100%
      );
      border-radius: 0px 0px 0px 0px;
      right: 0;
    }
    .part-box {
      // mask-image: linear-gradient(90deg,transparent,#fff 20%,#fff 80%,transparent);
      // background: #fff;
    //   .imgbox2,.imgbox4  {
    //     padding-left: 10px;
    //     padding-right: 10px;
    //   }
    }
    // .part-box1 {
    //   .imgbox4 {
    //     padding-left: 50px;
    //   }
    // }
  }
}
.section11 {
  // height: 1000px;
  background: #f4f6fb;
  padding-top: 6px;
  padding-bottom: 72px;
  min-height: 552px;
  background: url("../../assets/images/home/背景@2x.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 72px;
  box-sizing: border-box;
//   margin-bottom: 68px;
  .grid-container {
    display: grid;
    grid-template-columns: 224px 224px 224px 224px 224px;
    grid-gap: 20px;
    padding:0 10px;
    width: 1202px;
    margin: 0 auto;
  }
  .grid-container > div {
    background-color: rgba(255, 255, 255, 0.8);
    text-align: center;
    //  &:first-child{
    //      grid-column: 1 / span 3;
    //  }
  }

  .item11 {
    height: 88px;
    background: #ffffff;
    box-shadow: 2px 2px 6px 1px rgba(191, 123, 63, 0.16);
    border-radius: 10px 10px 10px 10px;
    box-sizing: border-box;
    .first {
      background: #fe9c2c;
      box-shadow: 2px 2px 6px 1px rgba(191, 123, 63, 0.19);
      border-radius: 10px 10px 10px 10px;
      height: 100%;
      padding: 10px 20px;
      box-sizing: border-box;
      width: 712px;
      height: 88px;
      z-index: 123;
      position: absolute;
      .names {
        position: relative;
        padding-right: 32px;
        box-sizing: border-box;
        &::after {
          content: " ";
          display: inline-block;
          position: absolute;
          width: 1px;
          height: 44px;
          background: #ffd5b2;
          right: 1px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .centers {
        height: 100%;
      }
      .s_icon {
        width: 90px;
        height: 80px;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .active_item {
      display: flex;
      z-index: 10000 !important;
      box-sizing: border-box;
      animation: myfirst 0.5s;
      -webkit-animation: myfirst 0.5s; /* Safari and Chrome */
      animation-timing-function: linear;
      font-size: 14px;
      &.toleft {
        position: absolute;
        top: 0;
        right: 0;
      }
      &.toright {
        position: absolute;
        top: 0;
        left: 0;
      }
      .left {
        width: 220px;
        height: 100%;
        background: #e78b36;
        padding: 27px 0 22px 50px;
        box-sizing: border-box;
        .name {
          display: flex;
          align-items: center;
          img {
            width: 34px;
            height: 36px;
          }
          .textname {
            font-size: 24px;
            color: #f9f8f9;
            font-family: Source Han Sans CN;
            margin-left: 10px;
          }
        }
        // .cityTag {
        //   margin-top: 25px;
        //   color: #f9f8f9;
        //   font-size: 12px;
        // }
      }
      .right {
        width: 572px;
        height: 110px;
        background: #f8953a;
        padding: 0 0 0 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .mr-28 {
          // margin-right: 20px;
          width: 450px;
        }
        img {
          width: 90px;
          height: 80px;
        }
        p {
          font-size: 14px;
          font-family: Source Han Sans CN;
          line-height: 24px;
          color: #f9f8f9;
        }
      }
      .engeng {
        opacity: 0.35;
        margin-top: 6px;
      }
    }
    .other-item {
      .s_n_icon {
        width: 90px;
        height: 80px;
        color: #fe9c2c;
      }
      .jiantou {
        width: 20px;
        height: 20px;
      }
      .lefts {
        padding: 16px 20px;
        padding-right: 0;
        box-sizing: border-box;
        text-align: left;
        span {
          color: #ec6900;
        }
        .col-FE8 {
          color: #fe8829;
        }
        .jiantou {
          margin-left: 20px;
        }
      }
    }
  }
}
@keyframes myfirst {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes tops {
  0% {
    top: 0px;
  }
  100% {
    top: -10px;
  }
}
@keyframes lunbo {
  from {
    transform: translate(100%);
  }
  to {
    transform: translate(-100%);
  }
}
@keyframes lunbo2 {
  from {
    transform: translate(0);
  }
  to {
    transform: translate(-200%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue